import styled from 'styled-components';

const Animation = styled.div`
  svg {
    min-width: 900px;
    width: 100%;
    height: 80%;
    position: absolute;
    top: -200px;
    left: 0;
    animation: scrollIn 1s forwards;

    @media (min-width: 770px) {
      height: 90%;
      max-height: 800px;
      margin-top: -5px;
    }
  }

  .waveMiddle {
    animation: fill 2s forwards;
    transform: scale(1.04);
    opacity: 0;
  }

  .waveBottom {
    animation: fill 6s forwards;
    transform: scale(1.01);
    opacity: 0;
  }

  @keyframes fill {
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes scrollIn {
    to {
      top: 0px;
    }
  }
`;

const Background = styled.div`
  div {
    background: #265689;
    position: absolute;
    width: 100%;
    height: 45vh;
    top: 0;
    left: 0;

    @media (min-width: 770px) {
      height: 35vh;
    }
  }
`;

const Wave = () => {
  return (
    <>
      <Background />
      <Animation
        dangerouslySetInnerHTML={{
          __html: `
        <svg preserveAspectRatio="none" viewBox="0 0 2560 1440">
          <path class="waveBottom" 
              d="M-0.773,752.994c0,-0 59.459,27.405 112.979,48.25c81.484,31.737 260.708,117.776 348.341,155.883c119.817,52.101 425.005,227.619 703.135,327.736c301.106,108.387 576.161,137.755 634.837,139.318c18.191,0.485 254.732,7.234 408.657,-15.027c135.606,-19.612 352.77,-99.933 352.77,-99.933l0,-1308.97l-2560.72,-0"
              style="fill:#99ccff;" />
          <path class="waveMiddle" 
              d="M-1.1,703.994c0,-0 28.485,22.405 89.201,50.25c78.159,35.845 255.713,117.776 341.667,155.883c117.522,52.101 416.863,227.619 689.664,327.736c295.337,108.387 565.123,137.755 622.675,139.318c17.843,0.485 250.233,9.686 400.828,-15.027c132.834,-21.799 417.675,-117.581 417.675,-117.581l0,-1244.32l-2561.71,-0"
              style="fill:#5089c5;" />
          <path 
              d="M-0.47,659.994c27.125,12.083 35.214,15.644 83.374,36.25c71.807,30.723 233.102,117.776 311.455,155.883c107.13,52.101 380.001,227.619 628.679,327.736c269.221,108.387 515.274,135.4 567.613,139.318c73.265,5.485 227.235,3.717 365.384,-15.027c218.246,-29.612 331.118,-70.667 479.575,-149.415c66.995,-35.537 125,-68.504 125,-68.504l0,-1086.98l-2561.08,-0"
              style="fill:#265689;;" />
        </svg>
        `,
        }}
      />
    </>
  );
};

export default Wave;
